import { ComponentProps, FC } from 'react';
import Select from 'react-select';
import { theme } from '~/styles';
import { CSSProperties } from 'react';
import { Option } from '~/types/products';
import ComparePlansDropdownStyled from './ComparePlansDropdownStyled';

interface Props extends ComponentProps<typeof Select> {
  options: Option[];
  defaultValue?: Option;
  onSelect: (option: Option) => void;
  selectedPlan?: Option;
  formatOptionLabel?: (option: Option) => string;
}

const selectStyles = {
  container: (styles: CSSProperties): CSSProperties => ({
    ...styles,
    fontWeight: 500,
  }),
  control: (styles: CSSProperties): CSSProperties => {
    return {
      ...styles,
      border: 'none',
      boxShadow: 'none',
      borderRadius: 0,
    };
  },
  valueContainer: (styles: CSSProperties): CSSProperties => ({
    ...styles,
    paddingRight: 0,
    margin: 0,
  }),
  indicatorSeparator: (): CSSProperties => ({
    display: 'none',
  }),
  dropdownIndicator: (styles: CSSProperties): CSSProperties => ({
    ...styles,
    color: theme.colors.primary.darkBlue,
  }),
  menu: (styles: CSSProperties) => ({
    ...styles,
    marginTop: 0,
    borderRadius: 0,
  }),
  option: (base) => {
    return {
      ...base,
      backgroundColor: 'transparent',
      cursor: 'pointer',
    };
  },
};

const ComparePlansDropdown: FC<Props> = ({ options, onSelect, defaultValue, selectedPlan, ...rest }) => {
  return (
    <ComparePlansDropdownStyled>
      <Select
        className="dropdown"
        placeholder="Select Plan"
        options={options}
        onChange={onSelect}
        defaultValue={defaultValue}
        styles={selectStyles}
        isSearchable={false}
        value={selectedPlan}
        {...rest}
      />
    </ComparePlansDropdownStyled>
  );
};

export default ComparePlansDropdown;
ComparePlansDropdown.displayName = 'ComparePlansDropdown';
